angular.module('impactx.orderconfirmation').controller('OrderConfirmationSupplierListCtrl', [
    'selectedListItems',
    OrderConfirmationSupplierListCtrl
]);

function OrderConfirmationSupplierListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewOrderConfirmationSupplier'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/orderconfirmation/templates/orderconfirmationsupplierlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/orderconfirmation/listsupplier',
        id: "orderconfirmationsupplierlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "orderconfirmationsupplier/" + selectedListItems.getFirstSelectedItem().pohId;
    }
}